import { SvgIcon, SvgIconProps } from '@mui/material';
import { memo } from 'react';
const SvgList32 = (props: SvgIconProps) => {
  const { sx, ...other } = props;
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      sx={{
        ...sx,
      }}
      {...other}
    >
      <path
        d="M8.5 23c.78 0 1.42.59 1.493 1.355L10 24.5c0 .78-.59 1.42-1.355 1.493L8.5 26c-.828 0-1.5-.666-1.5-1.5 0-.78.59-1.42 1.355-1.493L8.5 23Zm15.501 0c.552 0 .999.443.999.999v1.002a.999.999 0 0 1-.999.999H13a.996.996 0 0 1-.999-.999v-1.002c0-.552.447-.999.999-.999H24ZM8.5 15c.78 0 1.42.59 1.493 1.355L10 16.5c0 .78-.59 1.42-1.355 1.493L8.5 18c-.828 0-1.5-.666-1.5-1.5 0-.78.59-1.42 1.355-1.493L8.5 15Zm15.501 0c.552 0 .999.443.999.999v1.002a.999.999 0 0 1-.999.999H13a.996.996 0 0 1-.999-.999v-1.002c0-.552.447-.999.999-.999H24ZM8.5 7c.78 0 1.42.59 1.493 1.355L10 8.5c0 .78-.59 1.42-1.355 1.493L8.5 10C7.672 10 7 9.334 7 8.5c0-.78.59-1.42 1.355-1.493L8.5 7Zm15.501 0c.552 0 .999.443.999.999v1.002a.999.999 0 0 1-.999.999H13A.996.996 0 0 1 12 9.001V7.999c0-.552.447-.999.999-.999H24Z"
        className="list-32_svg__path-1"
      />
    </SvgIcon>
  );
};
const Memo = memo(SvgList32);
export default Memo;
